module.exports = __webpack_public_path__ + "img/AGDLP.ca93446f.png";